import publicBuill from '../js/publicBuill'
import examineTemplate from '../examineTemplate'
import tableTemplate from '../tableTemplate'
import billTitleTemplate from '../billTitleTemplate'
import invoiceTable from '../invoiceTable'

export default {
  components: {
    examineTemplate,
    tableTemplate,
    billTitleTemplate,
    invoiceTable
  },
  props: {
    // eslint-disable-next-line vue/require-default-prop
    property: Object,
    // eslint-disable-next-line vue/require-default-prop
    view: String,
    // eslint-disable-next-line vue/prop-name-casing
    AccountingReview: Boolean,
    toVoid: Boolean
  },
  data() {
    return {
      user: {},
      show: true,
      fksqd: {},
      hrdwmc: '',
      gys: '',
      gysbm: '',
      gyslb: '',
      hrdwzh: '',
      hrdwkhh: '',
      lcPersons: ['', '', '', '', '', '', '', '', '', ''], // 流程人员
      examineTemplate: {
        workflowData: []
      },
      /* 编辑需要数据 */
      optionsdjlb: [{
        value: '',
        label: ''
      }],
      optionsbizhong: [
        {
          value: '人民币',
          label: '人民币'
        }, {
          value: '美元',
          label: '美元'
        }, {
          value: '欧元',
          label: '欧元'
        }
      ],
      optionscwjzdw: [
        {
          label: '供应商',
          options: []
        }, {
          label: '客户',
          options: []
        }
      ],
      optionsFyBxUser: [],
      ljyf: '0.00',
      yfk: '0.00',
      yfje: '0.00',
      activeName: 'second',
      tableData: [],
      tableLabel: [
        {
          label: '日期',
          prop: 'num1',
          width: '110'
        },
        {
          label: '摘要',
          prop: 'num2',
          width: '250'
        },
        {
          label: '凭证号',
          prop: 'num3',
          width: '80'
        },
        {
          label: '票据号',
          prop: 'num4',
          width: '80'
        },
        {
          label: '已付',
          prop: 'num5',
          width: '140'
        },
        {
          label: '应付',
          prop: 'num6',
          width: '140'
        },
        {
          label: '余额',
          prop: 'num7',
          width: '140'
        }

      ],
      /* 审核需要数据 */
      oaSqdSh: {
        userNo: localStorage.getItem('userNo'),
        isAgree: '',
        shyj: '',
        documentType: '',
        flowId: '',
        maindjh: '',
        lb: '',
        shr: localStorage.getItem('userName'),
        shrNo: localStorage.getItem('userNo'),
        shje: ''
      },
      saveUrl: '',
      jeDx: '',
      jeXx: '',
      files: [],
      invoiceArr: [],
      invoiceDelArr: [],
      invoice: {
        vatInvoice: {},
        commodityList: []
      },
      invoiceChange: false
    }
  },

  created() {
    publicBuill.setThis(this)
    this.initData(this.property)
    if (this.view === 'edit') { // 编辑时 数据准备
      /* 获取单据类别 */
      this.$post('/fesback/fksqd/getFksqdDjlb.z').then(response => {
        response.forEach(value => {
          const item = {}
          item.value = value.subjectCode
          item.label = value.subjectName
          this.optionsdjlb.push(item)
        })
      })
      publicBuill.getFyBxUser().then(r => {})
    }
  },
  methods: {
    /* 数据初始化 */
    initData(billDataAll) {
      this.user.companyTitle = billDataAll.company
      const fksqd = billDataAll.BillData
      this.fksqd = fksqd
      /* 审核使用字段 */
      this.oaSqdSh.maindjh = fksqd.djh
      this.oaSqdSh.flowId = fksqd.flowId
      this.oaSqdSh.shje = fksqd.je
      this.oaSqdSh.documentType = 'fksqd0'
      this.oaSqdSh.lb = 'fksqd'

      this.fksqd.lrrId = localStorage.getItem('userNo')
      this.fksqd.rq = this.fksqd.rq.split(' ')[0]

      this.saveUrl = fksqd.rejected === '1' ? '/fesback/fksqd/restartWorkflow.z' : '/fesback/fksqd/edit.z'
      if (this.AccountingReview) {
        this.saveUrl = '/fesback/fksqd/editAccountingReview.z'
        this.fksqd.hsr = localStorage.getItem('userName')
        this.fksqd.hssm = '单据原本金额为:' + fksqd.je
      }
      this.jeDx = publicBuill.convertCurrency(fksqd.je)
      this.jeXx = publicBuill.formatAmount(fksqd.je)
      this.examineTemplate.workflowData = []
      /* 工作流信息 */
      if (billDataAll.examineData) {
        for (let i = 0; i < billDataAll.examineData.length; i++) {
          const val = billDataAll.examineData[i]
          const nodeName = val.lcName
          let lcid = val.lcid.split('fksqd')[1]
          if (nodeName === '经办人') {
            val.auditStatus = '提交'
          } else if (val.shbz === '0') {
            val.auditStatus = '退回'
          } else {
            val.auditStatus = '批准'
          }
          if (nodeName !== '经办人') {
            const receivedPersons = val.shr
            if (receivedPersons === '马祥') {
              lcid = '02'
            }
            if (nodeName === '董事长' || (lcid === '08' && !fksqd.flowId)) {
              this.lcPersons[9] = receivedPersons
            } else if (nodeName === '集团总裁' || (lcid === '09' && !fksqd.flowId)) {
              this.lcPersons[8] = receivedPersons
            } else if (nodeName === '集团财务总监' || (lcid === '07' && !fksqd.flowId)) {
              this.lcPersons[7] = receivedPersons
              this.lcPersons[6] = receivedPersons
            } else if (nodeName === '总经理' || (lcid === '05' && !fksqd.flowId)) {
              this.lcPersons[5] = receivedPersons
            } else if (nodeName === '总会计师' || (lcid === '06' && !fksqd.flowId)) {
              this.lcPersons[4] = receivedPersons
            } else if (nodeName === '副总经理' || (lcid === '03' && !fksqd.flowId)) {
              this.lcPersons[3] = receivedPersons
            } else if (nodeName === '财务部长' || (lcid === '04' && !fksqd.flowId)) {
              this.lcPersons[2] = receivedPersons
            } else if (nodeName === '部门负责人' || (lcid === '01' && !fksqd.flowId)) {
              this.lcPersons[1] = receivedPersons
            } else if (nodeName === '审核会计' || (lcid === '02' && !fksqd.flowId)) {
              this.lcPersons[0] = receivedPersons
            }
          }
          if (val.shr)
            this.examineTemplate.workflowData.push(val)
          if (i === 0 && nodeName !== '归档' && fksqd.recipient) {
            this.examineTemplate.workflowData.unshift({
              shr: fksqd.recipient,
              auditStatus: '未办理'
            })
          }
        }
      }
      /* 供应商明细 */
      const gysItem = {
        num2: fksqd.hrdwmc
      }
      publicBuill.getSupplierDetailsByName(gysItem)
    },
    agreeClick() {
      publicBuill.agreeClick()
    },
    refuseClick() {
      publicBuill.refuseClick()
    },
    queryBillData() {
      this.$emit('queryBillData')
      this.fksqdClose()
    },
    save() {
      const loading = this.$loading({
        lock: true,
        text: '数据保存中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      Promise.all([
        this.saveInvoice(),
        this.saveData()
      ]).then(res => {
        for (const element of res) {
          if (!element.success) {
            this.$message.error(element.message)
          }
        }
        this.$message.success('数据更新完成。')
        loading.close()
      })
    },
    async saveData() {
      return await this.$post(this.saveUrl, this.fksqd).then(response => {
        if (response.success) {
          this.fksqdClose()
        }
        return response
      }).catch(err => {
        return { message: '非预期错误' + err, success: false }
      })
    },
    async saveInvoice() {
      if (this.invoiceDelArr && this.invoiceDelArr.length > 0) {
        const r2 = await publicBuill.deleteInvoiceByInfo(this.invoiceDelArr)
        if (!r2.success) {
          return r2
        }
      }
      if (this.invoiceArr.length > 0) {
        const r1 = await publicBuill.vatInvoiceUpload(this.fksqd.djh)
        if (!r1.success) {
          return r1
        }
      }
      return { success: true, message: '更新完成' }
    },
    fksqdClose() {
      this.show = false
      this.$emit('fksqdClose')
    },
    remoteMethod(query) {
      publicBuill.remoteMethod(query)
    },
    changecwjzdw(event) {
      publicBuill.changecwjzdw(event)
      publicBuill.getFKsqdZhAndKhhByGys(this.gys).then(res => {
        this.fksqd.hrdwzh = this.hrdwzh
        this.fksqd.hrdwkhh = this.hrdwkhh
      })
      this.tableData = []
      /* 同步展示供应商明细数据 */
      const gysItem = {
        num2: event.name
      }
      publicBuill.getSupplierDetailsByName(gysItem)
    },
    changejkr(event) {
      this.fksqd.jkr = event[0]
      this.fksqd.jkrid = event[1]
      this.$post('/fesback/fybxd/getUserYsInfo.z', { jkr: this.fksqd.jkr }).then(res => {
        if (res.jkrYsDeptCode && res.jkrYsDeptName) {
          this.fksqd.jkrYsDeptCode = res.jkrYsDeptCode
          this.fksqd.jkrYsDeptName = res.jkrYsDeptName
        }
      })
    },
    jeChange() {
      this.jeDx = publicBuill.convertCurrency(this.fksqd.je)
      this.fksqd.tgje = this.fksqd.je
    },
    // 回填
    backFill(vatInvoice, commodityList) {
      this.invoice.vatInvoice = vatInvoice
      this.invoice.commodityList = commodityList
      if (this.invoice.commodityList && this.invoice.commodityList.length > 0) {
        this.fksqd.hkyt = this.invoice.commodityList[0].name
      }
      if (this.invoice.vatInvoice) {
        const bank = this.invoice.vatInvoice.sellerBank //购方开户行及账号
        if (bank && bank !== '' && bank !== undefined) {
          const bankarr = bank.split('行')
          let bankName = ''
          for (let i = 0; i < bankarr.length; i++) {
            if (i === bankarr.length - 1) {
              this.fksqd.hrdwzh = bankarr[bankarr.length - 1]
            } else {
              bankName += bankarr[i] + '行'
            }
          }
          this.fksqd.hrdwkhh = bankName
        }
        const je = this.invoice.vatInvoice.amountInFiguers //价税合计
        if (je && je !== '' && je !== undefined) {
          this.fksqd.je = je
          this.jeChange()
        }
        const name = this.invoice.vatInvoice.sellerName //购方名称
        if (name && name !== '' && name !== undefined) {
          this.$post('/fesback/fksqd/getFksqdGysByName.z', { subjectName: name }).then(res => {
            if (res && res.length > 0) {
              const item = res[0]
              this.fksqd.gyslb = '0'
              this.fksqd.gys = item.subjectName
              this.fksqd.hrdwmc = item.subjectName
              this.fksqd.gysbm = item.subjectCode
            }
          })
        }
      }
    },
    updateInvoice(val) {
      this.invoiceArr = val
      this.invoiceChange = true
    },
    delInvoice(val) {
      val.forEach(val => {
        this.invoiceDelArr.push(val)
      })
    }
  }
}
